export default class VisualizationSelectors {
    static CLASS_NAMES = {
        // use selector with "row-selected" because when scroll table we reuse the same rows and cells,
        // so in selected cell can be another value
        activeCellInSelectedRow: `.row-selected .v-table-body-row-cell--selected`,
        selectedCellClassName: "v-table-body-row-cell--selected",
    }
}